import { Screen } from '@modules/shared/services/window.service';
import { RibbonSliderNavigationConfigInterface } from '@modules/slider/interfaces/ribbon-slider.interface';

export const TEST_CAR_PAGE_RIBBON_SLIDER_CONFIG: RibbonSliderNavigationConfigInterface = {
  itemsToShow: 1,
  navigationCap: 0,
  showNavigation: true,
  breakpoints: {
    [Screen.XXS]: {
      itemsToShow: 1,
      navigationCap: 0,
      showNavigation: true,
    },
    [Screen.XS]: {
      itemsToShow: 2,
      navigationCap: 1,
      showNavigation: true,
    },
    [Screen.SM]: {
      itemsToShow: 2,
      navigationCap: 1,
      showNavigation: true,
    },
    [Screen.MD]: {
      itemsToShow: 3,
      navigationCap: 2,
      showNavigation: true,
    },
    [Screen.LG]: {
      itemsToShow: 4,
      navigationCap: 3,
      showNavigation: true,
    },
  },
};
